import React from "react";
import Select from "react-select";
import { defaultTheme } from "react-select";
import { Button } from "reactstrap";
import eventEmitter from "../../../../../../../util/emitter";
import {
  Link,
  ApiUrl,
  Axios,
  toast,
  Col,
  Row,
  Loading,
} from "../../../../../../../components";

const { API_SEARCH_ZOOM_TOPIC, API_DELETE_ZOOM_TOPIC } = ApiUrl;

const { colors } = defaultTheme;

const selectStyles = {
  control: (provided) => ({ ...provided, minWidth: 240, margin: 8 }),
  menu: () => ({ boxShadow: "inset 0 1px 0 rgba(0, 0, 0, 0.1)" }),
};

class SelectSearch extends React.Component {
  state = {
    isOpen: false,
    value: undefined,
    options: [],
    isProcessing: false,
  };
  toggleOpen = () => {
    this.setState((state) => ({ isOpen: !state.isOpen }));
  };
  onSelectChange = (value) => {
    this.toggleOpen();
    this.setState({ value });
  };
  handleChecked = (event) => {
    const { name, checked } = event.target;
    this.setState((prevState) => ({
      checkedItems: {
        ...prevState.checkedItems,
        [name]: checked,
      },
    }));
  };
  onInputChange1 = (value) => {
    this.setState({ value });
    const data = {
      topic: value,
      cases_id: this.props.isCheck,
    };
    Axios.Post(API_SEARCH_ZOOM_TOPIC, data)
      .then((res) => {
        if (res.data.success === true) {
          var data = res.data.data;
          const statedata =
            data?.length > 0 &&
            data.map((h) => {
              return { value: h, label: h };
            });

          this.setState({ options: statedata });
        } else {
          toast.error(res.data.error);
        }
      })
      .catch((error) => {
        console.log(error, "res.message");
      });
  };

  onInputChange = (value) => {
    if (value.length >= 1) {
      const data = {
        topic: value,
        cases_id: this.props.isCheck,
      };
      Axios.post(API_SEARCH_ZOOM_TOPIC, data)
        .then((res) => {
          if (res.data.success === true) {
            var data = res?.data?.data;
            const statedata =
              data?.length > 0 &&
              data.map((h) => {
                return { value: h, label: h };
              });
            this.setState({ options: statedata || [] });
          } else {
            toast.error(res.data.error);
          }
        })
        .catch((error) => {

        });
    }
  };

  handleSubmit = async () => {
    if (this.state.isProcessing) return;
    this.setState({ isProcessing: true });

    try {
      const data = {
        cases_id: this.props.isCheck,
        topic: this.state.value.label,
      };
      const response = await Axios.post(API_DELETE_ZOOM_TOPIC, data);
      if (response.status === 200) {
        toast.success("Hearing Deleted Successfully");

        this.setState({
          isOpen: false,
          value: null,
          checkedItems: [],
          options: []
        });
        eventEmitter.emit("closeZoomModal");
        handleCancelAss(false);
      }
    } catch (error) {
      console.error("Error deleting hearing:", error.message);
    } finally {
      this.setState({ isProcessing: false });
    }
  };

  render() {
    const { isOpen, value, options, checkedItems, isProcessing } = this.state;

    return (
      <>
        <Dropdown
          isOpen={isOpen}
          onClose={this.toggleOpen}
          target={
            <button
              iconAfter={<ChevronDown />}
              onClick={this.toggleOpen}
              isSelected={isOpen}
              className="search-certified"
            >
              {value ? ` ${value.label}` : "Search a Topic..."}
            </button>
          }
        >
          <Select
            autoFocus
            backspaceRemovesValue={false}
            components={{ DropdownIndicator, IndicatorSeparator: null }}
            controlShouldRenderValue={false}
            hideSelectedOptions={false}
            isClearable={false}
            menuIsOpen
            onChange={this.onSelectChange}
            onInputChange={this.onInputChange}
            options={options}
            placeholder="Search..."
            styles={selectStyles}
            tabSelectsValue={false}
            value={value}
          />
        </Dropdown>

        {value && (
          <>
            <button
              className="gnrate-certi-btn mt-2"
              onClick={this.handleSubmit}
              disabled={isProcessing}
            >
              {isProcessing ? <Loading /> : "Delete Hearing"}
            </button>
          </>
        )}

      </>
    );
  }
}

const Menu = (props) => {
  const shadow = "hsla(218, 50%, 10%, 0.1)";
  return (
    <div
      css={{
        backgroundColor: "white",
        borderRadius: 4,
        boxShadow: `0 0 0 1px ${shadow}, 0 4px 11px ${shadow}`,
        marginTop: 8,
        position: "absolute",
        zIndex: 2,
      }}
      {...props}
    />
  );
};
const Blanket = (props) => (
  <div
    css={{
      bottom: 0,
      left: 0,
      top: 0,
      right: 0,
      position: "fixed",
      zIndex: 1,
    }}
    {...props}
  />
);
const Dropdown = ({ children, isOpen, target, onClose }) => (
  <div css={{ position: "relative" }}>
    {target}
    {isOpen ? <Menu>{children}</Menu> : null}
    {isOpen ? <Blanket onClick={onClose} /> : null}
  </div>
);
const Svg = (p) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    focusable="false"
    role="presentation"
    {...p}
  />
);
const DropdownIndicator = () => (
  <div css={{ color: colors.neutral20, height: 24, width: 32 }}>
    <Svg>
      <path
        d="M16.436 15.085l3.94 4.01a1 1 0 0 1-1.425 1.402l-3.938-4.006a7.5 7.5 0 1 1 1.423-1.406zM10.5 16a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </Svg>
  </div>
);
const ChevronDown = () => (
  <Svg style={{ marginRight: -6 }}>
    <path
      d="M8.292 10.293a1.009 1.009 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.01 1.01 0 0 0 0-1.419.987.987 0 0 0-1.406 0l-2.298 2.317-2.307-2.327a.99.99 0 0 0-1.406 0z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </Svg>
);

export default SelectSearch;